import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Nav.css';

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
  }, [menuOpen]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <nav id="nav" className={scrolled ? 'scrolled' : ''}>
        <Link to="/" className="nav-logo">
          <span className="nav-logo-dot"></span>
          LIAM W <em>COACHING</em>
        </Link>
        <ul className="nav-links">
          <li><Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>About</Link></li>
          <li><Link to="/packages" className={location.pathname === '/packages' ? 'active' : ''}>Packages</Link></li>
          <li><Link to="/testimonials" className={location.pathname === '/testimonials' ? 'active' : ''}>Results</Link></li>
          <li><Link to="/faq" className={location.pathname === '/faq' ? 'active' : ''}>FAQ</Link></li>
        </ul>
        <Link to="/packages" className="nav-cta">Apply Now</Link>
        <button
          className={`hamburger${menuOpen ? ' open' : ''}`}
          id="ham"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen(o => !o)}
        >
          <span></span><span></span><span></span>
        </button>
      </nav>

      <div className={`mob-overlay${menuOpen ? ' open' : ''}`} id="mobOverlay">
        <Link to="/" onClick={closeMenu}>Home</Link>
        <Link to="/about" onClick={closeMenu}>About</Link>
        <Link to="/packages" onClick={closeMenu}>Packages</Link>
        <Link to="/testimonials" onClick={closeMenu}>Results</Link>
        <Link to="/faq" onClick={closeMenu}>FAQ</Link>
        <Link to="/packages" className="mob-cta" onClick={closeMenu}>Apply Now</Link>
      </div>
    </>
  );
}
